// extracted by mini-css-extract-plugin
module.exports = {"tools":"OrderTypesPage_tools__-Vf4w","mobileTools":"OrderTypesPage_mobileTools__3-cY1","page":"OrderTypesPage_page__2QfAR","right":"OrderTypesPage_right__1zs6l"};